import React, { Component } from 'react'
import t from 'tcomb-form'
import cn from 'classnames'
import FormUtils from '../lib/FormUtils'
import { connect } from 'react-redux'
import { push } from '../history'
import { resetPassword, changePassword } from '../actions/auth'
import { alert } from '../actions/alerts'
import { Link } from 'react-router-dom'
import Loading from '../components/Loading'

const steps = {
  reset: {
    email: {
      type: 'string',
      required: true,
      config: {type: 'login'},
      attrs: {
        type: 'email',
        placeholder: 'Email Address'
      }
    }
  },

  change: {
    token: {
      type: 'string',
      config: {type: 'login'},
      attrs: {placeholder: 'Verification Code'},
      required: true
    },
    password: {
      type: 'string',
      config: {type: 'login'},
      attrs: {type: 'password', placeholder: 'New Password'},
      required: true
    },
    passwordConfirm: {
      type: 'string',
      config: {type: 'login'},
      attrs: {type: 'password', placeholder: 'Confirm New Password'},
      required: true
    }
  }
}

@connect()
export default class ResetPassword extends Component {
  state = {
    step: 'reset',
    ...this.getForm('reset'),
    value: {}
  }

  getForm (step) {
    return FormUtils.getForm(steps[step])
  }

  onResend = async (e) => {
    e.preventDefault()
    const {dispatch} = this.props
    const {error} = await dispatch(resetPassword(this.state.email))
    if (error) {
      dispatch(alert({...error, type: 'error'}))
      this.setState({hasError: true})
    }
  }

  onChange = (value) => {
    this.setState({value, hasError: false})
  }

  onSubmit = async (e) => {
    e.preventDefault()
    const {step, value} = this.state
    const {dispatch} = this.props

    if (step === 'reset') {
      const {error} = await dispatch(resetPassword(value.email))
      if (error) {
        dispatch(alert({...error, type: 'error'}))
        this.setState({hasError: true})
        return
      }
      this.setState({step: 'change', ...this.getForm('change'), value: {},
        email: value.email, hasError: false})
    }

    if (step === 'change') {
      const {error} = await dispatch(changePassword({...value, email: this.state.email}))
      if (error) {
        dispatch(alert({...error, type: 'error'}))
        this.setState({hasError: true})
        return
      }

      dispatch(alert({message: 'Changed password successfully. Please sign in.', type: 'success'}))
      push('/login')
    }
  }

  render () {
    const {schema, options, value, loading, step, email, hasError} = this.state
    const className = cn({hasError})

    return <div className='absolute-center login-window'>
      <div className='branding-logo' />
      <h1>Reset Password</h1>
      <form onSubmit={this.onSubmit} className={className}>
        {(!loading && step === 'change') &&
          <div>
            <p>An email has been sent to <strong>{email}</strong> with a verification code.</p>
            <p>Didn't get it? <a role='button' onClick={this.onResend}>Send new code</a>.</p>
          </div>
        }
        {loading
          ? <Loading />
          : <t.form.Form type={schema} options={options} value={value} onChange={this.onChange} />
        }
        <button type='submit' className='login-btn'>Submit</button>
      </form>
      <Link to='/login'>Sign in with existing account</Link>
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/containers/ResetPassword.js